export default __webpack_public_path__ + "static/media/delete-modal.5f9ec652.svg";